import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { APIgetDownloadsUsers } from '../../api/Downloads';

import UsersFilter from '../Filters/Users';

const DownloadsFilters = ({ selectedUser, loading, handleChangeUser }) => {
  const loadUsers = useCallback(() => (
    APIgetDownloadsUsers()
  ), []);

  return (
    <div className="table-filters">
      <UsersFilter
        selectedUser={selectedUser}
        loading={loading}
        loadUsers={loadUsers}
        handleChangeUser={handleChangeUser}
      />
    </div>
  );
};

DownloadsFilters.propTypes = {
  selectedUser: PropTypes.object,
  loading: PropTypes.bool,
  handleChangeUser: PropTypes.func.isRequired,
};

DownloadsFilters.defaultProps = {
  selectedUser: null,
  loading: false,
};

export default DownloadsFilters;
